import { Vector2 } from '@babylonjs/core';
import { BaseShape } from './IShape';

export class WallModel extends BaseShape {
    constructor(
        public model: string,
        public light: string,
        public position: Vector2,
        public shape: Vector2,
        public isSupport: boolean = false,
    ) {
        super(position, shape);
    }

    public get isVertical(): boolean {
        return this.shape.x === 0;
    }
}
